export default {
  created: 'CREATED',
  approved: 'APPROVED'
}
